import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { cn } from "~/core/generic/shadcn-utils";

import { faXmark } from "@fortawesome/pro-regular-svg-icons";

export default function DDClearIcon({
  asSuffix = false,
}: {
  asSuffix?: boolean;
}) {
  return (
    <div
      className={cn("size-6", { "flex items-center justify-end": asSuffix })}
    >
      <div className="cursor-pointer bg-core-silver-8 rounded-full p-[1px] flex items-center justify-center size-3">
        <FontAwesomeIcon
          icon={faXmark}
          className="text-white-a12 bg-core-silver-8 rounded-full p-[1px]"
          size="xs"
        />
      </div>
    </div>
  );
}
